module.exports = __webpack_public_path__ + "img/advanced-weapons.715a3262.webp";